<template>
    <v-container
        v-if  = "site && current"
        class = "step-container"
    >
        <c-drop-message
            v-if     = "drag.notAllowed"
            :message ="drag.message"
        />

        <d-attach-confirm
            v-model = "attach.visible"
            :data   = "attach.data"
            @attach = "onAttach"
            @cancel = "onAttachCancel"
        />

        <drop @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
            <v-row class="no-frame">
                <v-col class="step-first-column" style="border: none; padding: 0;">
                    <div class="lm-border pa-3" style="flex: 1">
                        <!-- Status -->
                        <v-row class="no-frame mt-0" >
                            <v-col class="no-frame">
                                <inc-status
                                    v-model = "current.status"
                                    :items  = "step.status"
                                    :label  = "$t('invoice.status')"
                                    @change = "onStatusChanged"
                                />
                            </v-col>
                        </v-row>
                        <!-- Status -->

                        <!-- Processing time -->
                        <inc-processing-interval
                            :data       = "data"
                            :status     = "current.status"
                            :background = "collective ? 'field-group-background-blue' : ''"
                        />
                        <!-- Processing time -->

                        <!-- Order - main invoice -->
                        <v-row class="no-frame mt-0" >
                            <v-col class="no-frame mr-2">
                                <v-text-field
                                    :label            = "$t('invoice.ordernumber')"
                                    v-model           = "data.ordernumber"
                                    :background-color = "fileEntryFieldBackground"
                                    autocomplete      = "off"
                                    autocorrect       = "off"
                                    autocapitalize    = "off"
                                    spellcheck        = "false"
                                />
                            </v-col>
                        </v-row>
                        <!-- Order - main invoice -->

                        <!-- Description -->
                        <v-row
                            v-if="data.tags.includes('description')"
                            class="no-frame mt-9"
                        >
                            <v-textarea
                                :label            = "$t('invoice.description')"
                                v-model           = "data.description"
                                :background-color = "fileEntryFieldBackground"
                                rows              = "8"
                                autocomplete      = "off"
                                autocorrect       = "off"
                                autocapitalize    = "off"
                                spellcheck        = "false"
                                no-resize
                            />
                        </v-row>
                        <!-- Description -->

                        <v-row
                            v-if  = "index === 0 && complainReasonAllowed"
                            class = "no-frame mt-4"
                            style="display: block;flex:1;"
                        >
                            <v-textarea
                                v-model        = "data.complaintreason"
                                :label         = "$t('invoice.complaintreason')"
                                rows           = "8"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class="pt-0"
                                hide-details
                                no-resize
                            />
                        </v-row>
                    </div>
                </v-col>
                <v-col class="step-middle-column" style="border: none; padding: 0">
                    <!-- Total account -->
                    <p-mixed-invoice-sum
                        :invoice     = "data"
                        :status      = "current.status"
                        :collective  = "collective"
                        class        = "mb-3"
                        @stampmail   = "onSendStampMail"
                        @stamped     = "onStamped"
                    />
                    <!-- Total account -->

                    <!-- Receipients -->
                    <p-inc-invoice-recipients
                        usage       = "COSTS"
                        :separated  = "separated"
                        :recipients = "recipients"
                        :data       = "data"
                        :collective = "collective"
                        style       = "flex:1;"
                    />

                    <!-- Receipients -->
                </v-col>
                <v-col class="step-middle-column" style="max-width: calc(25% - 20px); border: none; padding: 0">
                    <!-- Abstract of maintenance contract data -->
                    <c-contract-mnt-abstract
                        :show-unit = "collective"
                        class      = "lm-border pa-3 mt-0 mb-3 contract-abstract"
                    />
                    <!-- Abstract of maintenance contract data -->

                    <v-row class = "no-frame lm-border pa-3">
                        <v-col class = "no-frame mt-0 col-12 ">
                            <v-row class="no-frame pr-1" v-if="collective">
                                <v-col class="no-frame">
                                    <f-title :title="$t('invoice.sum.maintenance')" />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame pb-2 pr-1" v-if="collective">
                                <v-col class="no-frame pr-2">
                                    <f-read-only-field
                                        :label       = "$t('invoice.cost.net')"
                                        :value       = "toMoney (sum.mnt.amount)"
                                        :align-right = "true"
                                        :collective  = "collective"
                                        :filled      = "!collective"
                                        dense
                                    />
                                </v-col>
                                <v-col class="no-frame pl-2">
                                    <f-read-only-field
                                        :label       = "$t('invoice.cost.correction')"
                                        :value       = "toMoney (sum.mnt.correction)"
                                        :align-right = "true"
                                        :collective  = "collective"
                                        :filled      = "!collective"
                                        dense
                                    />
                                </v-col>
                            </v-row>

                            <v-row class="no-frame" :class="collective ? 'mt-10' : ''">
                                <v-col class="no-frame">
                                    <f-title :title="getUnitText( $t('invoice.item.maintenance'))" />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame pr-2">
                                    <p-inc-invoice-amount
                                        :status          = "current"
                                        :item            = "current.item_1"
                                        :amount          = "current.item_1.amount"
                                        :show-costs      = "false"
                                        :form            = "form"
                                        :validate-amount = "true"
                                        :calculation     = "mntCalculation"
                                    />
                                </v-col>
                                <v-col class="no-frame pl-2">
                                    <p-inc-invoice-amount
                                        :label="$t('invoice.cost.correction')"
                                        :status          = "current"
                                        :item            = "current.item_1"
                                        :amount          = "current.item_1.correction"
                                        :show-costs      = "false"
                                        :form            = "form"
                                        :validate-amount = "false"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                </v-col>
                <v-col class="step-last-column" style="border: none; padding: 0">
                    <v-row v-if="!notice" class="w-100 no-frame" >
                        <v-col class="no-frame">
                            <c-contract-esc-abstract
                                :show-unit = "collective"
                                class      = "mb-3 contract-abstract"
                            />

                            <v-row class="no-frame lm-border pa-3" style="height: calc(100% - 277px);">
                                <v-col class="no-frame mt-0 col-12 ">
                                    <v-row class="no-frame pr-1" v-if="collective">
                                        <v-col class="no-frame">
                                            <f-title :title="$t('invoice.sum.emergency')" />
                                        </v-col>
                                    </v-row>
                                    <v-row class="no-frame pb-2 pr-1" v-if="collective">
                                        <v-col class="no-frame pr-2">
                                            <f-read-only-field
                                                :label       = "$t('invoice.cost.net')"
                                                :value       = "toMoney (sum.emc.amount)"
                                                :align-right = "true"
                                                :collective  = "collective"
                                                :filled      = "!collective"
                                                dense
                                            />
                                        </v-col>
                                        <v-col class="no-frame pl-2">
                                            <f-read-only-field
                                                :label       = "$t('invoice.cost.correction')"
                                                :value       = "toMoney (sum.emc.correction)"
                                                :align-right = "true"
                                                :collective  = "collective"
                                                :filled      = "!collective"
                                                dense
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row class="no-frame" :class="collective ? 'mt-10' : ''">
                                        <v-col class="no-frame">
                                            <f-title :title="getUnitText($t('invoice.item.emergency'))" />
                                        </v-col>
                                    </v-row>
                                    <v-row class="no-frame">
                                        <v-col class="no-frame pr-2">
                                            <p-inc-invoice-amount
                                                :status          = "current"
                                                :item            = "current.item_2"
                                                :amount          = "current.item_2.amount"
                                                :show-costs      = "false"
                                                :form            = "form"
                                                :validate-amount = "false"
                                            />
                                        </v-col>
                                        <v-col
                                            class="no-frame pl-2"
                                        >
                                            <p-inc-invoice-amount
                                                :label           = "$t('invoice.cost.correction')"
                                                :status          = "current"
                                                :item            = "current.item_2"
                                                :amount          = "current.item_2.correction"
                                                :show-costs      = "false"
                                                :form            = "form"
                                                :validate-amount = "false"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <c-v-spacer />
                            </v-row>
                        </v-col>

                    </v-row>
                    <v-row class="notice-column" v-show="notice">
                        <crm-journal
                            :incident="incident"
                            @front   ="onJournalFront"
                        />
                    </v-row>
                </v-col>
            </v-row>
        </drop>
    </v-container>
</template>

<script>

import { Drop }              from "vue-easy-dnd"
import Core                  from "@/modules/core/service/Core";
import Inc                   from "@/modules/inc/service/Inc";
import IncStatus             from "@/modules/inc/steps/components/common/IncStatus.vue";
import Site                  from "@/modules/msd/unit/service/Site";
import CDropMessage          from "@/modules/inc/steps/components/common/CDropMessage.vue";
import PMixedInvoiceSum      from "@/modules/inc/steps/components/invoice/private/PMixedInvoiceSum.vue";
import DAttachConfirm        from "@/modules/inc/steps/components/common/DAttachConfirm.vue";
import IncProcessingInterval from "@/modules/inc/steps/components/common/IncProcessingInterval.vue";
import CrmJournal            from "@/modules/crm/components/main/CrmJournal.vue";
import CContractMntAbstract  from "@/modules/msd/company/contract/components/controls/mnt/CContractMntAbstract.vue";
import CContractEscAbstract  from "@/modules/msd/company/contract/components/controls/esc/CContractEscAbstract.vue";
import PIncInvoiceRecipients from "@/modules/inc/steps/components/invoice/private/PIncInvoiceRecipients.vue";
import PIncInvoiceAmount     from "@/modules/inc/steps/components/invoice/private/PIncInvoiceAmount.vue";
import FTitle                from "@/modules/core/components/utils/FTitle.vue";
import CVSpacer              from "@/modules/core/components/utils/CVSpacer.vue";
import FReadOnlyField        from "@/modules/core/components/utils/FReadOnlyField.vue";
import InvoiceMixin          from "@/modules/inc/steps/components/mixins/InvoiceMixin";
import StepMixin             from "@/modules/inc/steps/components/mixins/StepMixin";

export default {
    name: "IncMnInvoice",

    mixins: [
        InvoiceMixin,
        StepMixin
    ],

    components: {
        DAttachConfirm,
        PMixedInvoiceSum,
        CDropMessage,
        FReadOnlyField,
        CVSpacer,
        FTitle,
        PIncInvoiceAmount,
        PIncInvoiceRecipients,
        CContractEscAbstract,
        CContractMntAbstract,
        CrmJournal,
        IncProcessingInterval,
        IncStatus,
        Drop
    },

    props: {
        incident: {

        },

        data: {
            required: true,
            type    : Object,
            default : function () {
                return {
                }
            },
        },
    },

    data: () => ({
        sum: {
            mnt: {
                amount     : null,
                correction : null,
            },
            emc: {
                amount     : null,
                correction : null,
            }
        },

        notice    : false,
        refresh   : 0,
        separated  : false,
        recipients : null
    }),

    computed: {
        site () {
            return this.$store.getters.site;
        },

        fileEntryFieldBackground () {
            return Inc.style.fileEntryFieldBackground(this.data);
        },

        contracts () {
            return this.$store.getters.site["liftmanagement"];
        },
    },

    created() {
        this.$bus.$on(this.$incident.events.context.entered, this.onContext);
        this.$bus.$on(this.$events.drag.end, this.onDragend);
        this.freeze = JSON.stringify(this.data);
        this.form = this.$parent;
        this.bus.$on (Inc.events.notice, (show) => {
            this.notice = show;
        });
    },

    beforeDestroy() {
        this.$bus.$off(this.$incident.events.context.entered, this.onContext);
        this.$bus.$off(this.$events.drag.end, this.onDragend);
    },

    mounted() {
        this.form = this.$parent;
        this.$nextTick(() => {
            this.form.validate();
            this.initBase();
        });
    },

    watch: {
        current: {
            deep: true,
            handler:function () {
                this.calculateInvoice();
            }
        },

        site () {
           this.loadRecipients();
            this.calculateInvoice();
        }
    },

    methods: {
        _validate () {
            this.form.validate();
        },

        /**
         * Sets the given unit als new context for the processing step. T
         *
         * @param unit the new unit context.
         */
        _setContext (unit) {
            this.unit = unit;
            this.$nextTick(() => {
                this.loadRecipients();
            })
        },

        /**
         * Checks if the current processing step is terminated.
         * @returns true, if the processing step is terminated, false otherwise.
         */
        _isTerminated () {
            return this.current.status.type !== 'T';
        },

        _status () {
            if (!this.current) {
                return null;
            }

            return this.current.status;
        },

        /**
         * Force an update of relevat componets. E.g. when the list of assigned sites changes.
         */
        _forceUpdate () {
            this.freeze = JSON.stringify(this.data);
        },

        _unitStepStatus () {
            if (!this.data.visible) {
                return null;
            }

            return this.form.value ? 'success' : 'error';
        },

        /**
         * Validate the processing step and inform the main dialog about a possible change.
         */
        validate () {
            this.form.validate();
            return Promise.resolve();
        },

        onContext () {
            this.$nextTick().then(() => {
                this.collective = this.incident.sites.length > 1;
            })
        },

        getUnitText (text) {
            return text + (this.collective ? ' (' + this.site.fabricNo + ')' : '');
        },

        calculateInvoice () {
            let sumAmount        = 0;
            let sumCorrection    = 0;
            let sumMntAmount     = 0;
            let sumMntCorrection = 0;
            let sumEmcAmount     = 0;
            let sumEmcCorrection = 0;

            this.data.collection.forEach(i => {
                sumAmount        += i.item_1.amount.net + i.item_2.amount.net;
                sumCorrection    += i.item_1.correction.net + i.item_2.correction.net;
                sumMntAmount     += i.item_1.amount.net;
                sumMntCorrection += i.item_1.correction.net;
                sumEmcAmount     += i.item_2.amount.net;
                sumEmcCorrection += i.item_2.correction.net;
            });

            this.data.item.calculated.net        = sumAmount;
            this.data.item.calculated.correction = sumCorrection;

            this.sum.mnt.amount     = sumMntAmount;
            this.sum.mnt.correction = sumMntCorrection;
            this.sum.emc.amount     = sumEmcAmount;
            this.sum.emc.correction = sumEmcCorrection;
        },

        toMoney (value) {
            return Core.format.money(value);
        },

        mntCalculation () {
            const contract = this.contracts["mntContract"];
            return contract.unit.costs / contract["invoicesPerYear"];
        },

        loadRecipients () {
            if (!this.site) {
                return;
            }

            let unitIds = this.incident.sites.map(s => s.id);
            if (!unitIds) {
                return;
            }

            this.separated = this.site.customer.recipientsSeparated;
            Site.recipients(unitIds, "COSTS",(data) => {
                this.recipients = data;
                this.recipients.invoice = this.prepareRecipientList(this.recipients.invoice, this.data.invoiceRecipient);
                this.recipients.benefit = this.prepareRecipientList(this.recipients.benefit, this.data.benefitRecipient);
                this.recipients.forward = this.prepareRecipientList(this.recipients.forward, this.data.forwardRecipient);
            });
        },

        prepareRecipientList (list, recipient) {
            if (!list || list.length === 0) {
                const result = [];
                if (recipient) {
                    Site.recipient(recipient.id, (data) => {
                        result.push (data);
                    });
                }

                return result;
            }

            if (recipient) {
                const index = list.findIndex(r => r.id === recipient.id);
                if (index < 0) {
                    Site.recipient(recipient.id, (data) => {
                        list.push (data);
                    });
                }
            }

            return list;
        },

        save () {
            this.$emit("save");
        },
    }
}
</script>

<style scoped>

.notice-column {
    margin-top: 0;
}

.contract-abstract {
    height: 257px!important
}

</style>